import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import {
  Wrapper,
  StyledContainer,
  Body,
  ImageWrapper,
  StyledImage,
  Content,
  StyledBottomLink,
  Footer,
  Achievements,
  Achievement,
  Award,
} from './styles';

// * (CMS UPDATES) Button style

// * cta {obj} contains the url for the link
// * ctaText {string} innerText of a CTA
// * buttonType {string} className to control CTA style
// * imageResearch {obj} the data for the image if displayed
// * bodyCopy {richText} data that makes up the body of the section
// * headingText {richText} data that makes up the subheading of the section
// * imageAward {obj} the data for the small essa logo to be displayed
// * colour1 {string} hexvalue for the first colour bar
// * colour2 {string} hexvalue for the second colour bar
// * labelColour1 {string} text for the first colour bar
// * labelColour2 {string} text for the second colour bar
// * title {richText} data that makes up the title of the section

const AcademicAchievement = ({ sectionId, data, className }) => {
  if (!data) return null;

  const {
    imageResearch,
    imageResearchSharp,
    cta,
    ctaText,
    buttonType,
    bodycopyHtml,
    headingTextHtml,
    imageAward,
    imageAwardSharp,
    colour1,
    colour2,
    labelColour1,
    labelColour2,
    titleHtml,
    ariaLabel,
    queryString,
  } = data.primary[0];

  return (
    <Wrapper id={sectionId} className={className}>
      <StyledContainer className="auto-margin">
        {ReactHtmlParser(titleHtml)}
        <Body>
          {imageResearch && (
            <ImageWrapper>
              <StyledImage
                src={imageResearchSharp}
                alt={imageResearch.altTag}
              />
            </ImageWrapper>
          )}
          <Content>
            {ReactHtmlParser(headingTextHtml)}
            {ReactHtmlParser(bodycopyHtml)}
            <Footer>
              <Achievements>
                <Achievement color={colour1}>
                  <p>{labelColour1}</p>
                </Achievement>
                <Achievement color={colour2}>
                  <p>{labelColour2}</p>
                </Achievement>
              </Achievements>
              <Award src={imageAwardSharp.publicURL} alt={imageAward.altTag} />
            </Footer>
          </Content>
        </Body>
        {cta && ctaText && (
          <StyledBottomLink
            to={cta.url}
            className={buttonType}
            ariaLabel={ariaLabel}
            queryString={queryString}
          >
            {ctaText}
          </StyledBottomLink>
        )}
      </StyledContainer>
    </Wrapper>
  );
};

AcademicAchievement.propTypes = {
  data: PropTypes.shape().isRequired,
  className: PropTypes.string,
  sectionId: PropTypes.string.isRequired,
};

AcademicAchievement.defaultProps = {
  className: null,
};

export default AcademicAchievement;
